import api from '../../../shared/services/apiClient';
import { Company } from '@/types';

export const getCompanies = async (): Promise<Company[]> => {
  try {
    const res = await api.get('/companies');
    if (Array.isArray(res.data)) return res.data as Company[];
    return (res.data?.companies || []) as Company[];
  } catch (error: any) {
    console.error('Error loading companies:', error?.response?.status, error?.message);
    throw error;
  }
};

export const createCompany = async (data: Omit<Company, 'id'>) => {
  const res = await api.post('/companies', data);
  return res.data as Company;
};

export const updateCompany = async (id: string | number, data: Partial<Company>) => {
  const res = await api.put(`/companies/${id}`, data);
  return res.data as Company;
};

export const deleteCompany = async (id: string | number) => {
  const res = await api.delete(`/companies/${id}`);
  return res.status === 200 || res.status === 204;
};

export default { getCompanies, createCompany, updateCompany, deleteCompany } as any;
